/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShipPreviousStockFlg } from './ShipPreviousStockFlg';
import {
    ShipPreviousStockFlgFromJSON,
    ShipPreviousStockFlgFromJSONTyped,
    ShipPreviousStockFlgToJSON,
    ShipPreviousStockFlgToJSONTyped,
} from './ShipPreviousStockFlg';
import type { InternalTransferHubFlg } from './InternalTransferHubFlg';
import {
    InternalTransferHubFlgFromJSON,
    InternalTransferHubFlgFromJSONTyped,
    InternalTransferHubFlgToJSON,
    InternalTransferHubFlgToJSONTyped,
} from './InternalTransferHubFlg';
import type { InternalInboundFlg } from './InternalInboundFlg';
import {
    InternalInboundFlgFromJSON,
    InternalInboundFlgFromJSONTyped,
    InternalInboundFlgToJSON,
    InternalInboundFlgToJSONTyped,
} from './InternalInboundFlg';
import type { TodayShipRecDelayFlg } from './TodayShipRecDelayFlg';
import {
    TodayShipRecDelayFlgFromJSON,
    TodayShipRecDelayFlgFromJSONTyped,
    TodayShipRecDelayFlgToJSON,
    TodayShipRecDelayFlgToJSONTyped,
} from './TodayShipRecDelayFlg';
import type { CalcStockShippingorderFlg } from './CalcStockShippingorderFlg';
import {
    CalcStockShippingorderFlgFromJSON,
    CalcStockShippingorderFlgFromJSONTyped,
    CalcStockShippingorderFlgToJSON,
    CalcStockShippingorderFlgToJSONTyped,
} from './CalcStockShippingorderFlg';

/**
 * 
 * @export
 * @interface MstCenter
 */
export interface MstCenter {
    /**
     * 
     * @type {number}
     * @memberof MstCenter
     */
    centerId: number | null;
    /**
     * 
     * @type {number}
     * @memberof MstCenter
     */
    companyId: number | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    orgCenterId: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    centerName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    centerAddress: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdayMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdayTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdayWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdayThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdayFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdaySat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableShipdaySun: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalSat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableArrivalSun: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdayMon: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdayTue: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdayWed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdayThu: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdayFri: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdaySat: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    enableOrderdaySun: boolean | null;
    /**
     * 
     * @type {ShipPreviousStockFlg}
     * @memberof MstCenter
     */
    shipPreviousStockFlg: ShipPreviousStockFlg | null;
    /**
     * 
     * @type {TodayShipRecDelayFlg}
     * @memberof MstCenter
     */
    todayShipRecDelayFlg: TodayShipRecDelayFlg | null;
    /**
     * 
     * @type {CalcStockShippingorderFlg}
     * @memberof MstCenter
     */
    calcStockShippingorderFlg: CalcStockShippingorderFlg | null;
    /**
     * 
     * @type {InternalTransferHubFlg}
     * @memberof MstCenter
     */
    internalTransferHubFlg: InternalTransferHubFlg | null;
    /**
     * 
     * @type {InternalInboundFlg}
     * @memberof MstCenter
     */
    internalInboundFlg: InternalInboundFlg | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    centerGroupName: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    centerGln: string | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    remarks: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenter
     */
    insertDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    insertUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenter
     */
    updateDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    updateUser: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MstCenter
     */
    deleteDatetime: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MstCenter
     */
    deleteUser: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MstCenter
     */
    deleteFlg: boolean | null;
}

/**
 * Check if a given object implements the MstCenter interface.
 */
export function instanceOfMstCenter(value: object): value is MstCenter {
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('orgCenterId' in value) || value['orgCenterId'] === undefined) return false;
    if (!('centerName' in value) || value['centerName'] === undefined) return false;
    if (!('centerAddress' in value) || value['centerAddress'] === undefined) return false;
    if (!('enableShipdayMon' in value) || value['enableShipdayMon'] === undefined) return false;
    if (!('enableShipdayTue' in value) || value['enableShipdayTue'] === undefined) return false;
    if (!('enableShipdayWed' in value) || value['enableShipdayWed'] === undefined) return false;
    if (!('enableShipdayThu' in value) || value['enableShipdayThu'] === undefined) return false;
    if (!('enableShipdayFri' in value) || value['enableShipdayFri'] === undefined) return false;
    if (!('enableShipdaySat' in value) || value['enableShipdaySat'] === undefined) return false;
    if (!('enableShipdaySun' in value) || value['enableShipdaySun'] === undefined) return false;
    if (!('enableArrivalMon' in value) || value['enableArrivalMon'] === undefined) return false;
    if (!('enableArrivalTue' in value) || value['enableArrivalTue'] === undefined) return false;
    if (!('enableArrivalWed' in value) || value['enableArrivalWed'] === undefined) return false;
    if (!('enableArrivalThu' in value) || value['enableArrivalThu'] === undefined) return false;
    if (!('enableArrivalFri' in value) || value['enableArrivalFri'] === undefined) return false;
    if (!('enableArrivalSat' in value) || value['enableArrivalSat'] === undefined) return false;
    if (!('enableArrivalSun' in value) || value['enableArrivalSun'] === undefined) return false;
    if (!('enableOrderdayMon' in value) || value['enableOrderdayMon'] === undefined) return false;
    if (!('enableOrderdayTue' in value) || value['enableOrderdayTue'] === undefined) return false;
    if (!('enableOrderdayWed' in value) || value['enableOrderdayWed'] === undefined) return false;
    if (!('enableOrderdayThu' in value) || value['enableOrderdayThu'] === undefined) return false;
    if (!('enableOrderdayFri' in value) || value['enableOrderdayFri'] === undefined) return false;
    if (!('enableOrderdaySat' in value) || value['enableOrderdaySat'] === undefined) return false;
    if (!('enableOrderdaySun' in value) || value['enableOrderdaySun'] === undefined) return false;
    if (!('shipPreviousStockFlg' in value) || value['shipPreviousStockFlg'] === undefined) return false;
    if (!('todayShipRecDelayFlg' in value) || value['todayShipRecDelayFlg'] === undefined) return false;
    if (!('calcStockShippingorderFlg' in value) || value['calcStockShippingorderFlg'] === undefined) return false;
    if (!('internalTransferHubFlg' in value) || value['internalTransferHubFlg'] === undefined) return false;
    if (!('internalInboundFlg' in value) || value['internalInboundFlg'] === undefined) return false;
    if (!('centerGroupName' in value) || value['centerGroupName'] === undefined) return false;
    if (!('centerGln' in value) || value['centerGln'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    if (!('insertDatetime' in value) || value['insertDatetime'] === undefined) return false;
    if (!('insertUser' in value) || value['insertUser'] === undefined) return false;
    if (!('updateDatetime' in value) || value['updateDatetime'] === undefined) return false;
    if (!('updateUser' in value) || value['updateUser'] === undefined) return false;
    if (!('deleteDatetime' in value) || value['deleteDatetime'] === undefined) return false;
    if (!('deleteUser' in value) || value['deleteUser'] === undefined) return false;
    if (!('deleteFlg' in value) || value['deleteFlg'] === undefined) return false;
    return true;
}

export function MstCenterFromJSON(json: any): MstCenter {
    return MstCenterFromJSONTyped(json, false);
}

export function MstCenterFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenter {
    if (json == null) {
        return json;
    }
    return {
        
        'centerId': json['center_id'],
        'companyId': json['company_id'],
        'orgCenterId': json['org_center_id'],
        'centerName': json['center_name'],
        'centerAddress': json['center_address'],
        'enableShipdayMon': json['enable_shipday_mon'],
        'enableShipdayTue': json['enable_shipday_tue'],
        'enableShipdayWed': json['enable_shipday_wed'],
        'enableShipdayThu': json['enable_shipday_thu'],
        'enableShipdayFri': json['enable_shipday_fri'],
        'enableShipdaySat': json['enable_shipday_sat'],
        'enableShipdaySun': json['enable_shipday_sun'],
        'enableArrivalMon': json['enable_arrival_mon'],
        'enableArrivalTue': json['enable_arrival_tue'],
        'enableArrivalWed': json['enable_arrival_wed'],
        'enableArrivalThu': json['enable_arrival_thu'],
        'enableArrivalFri': json['enable_arrival_fri'],
        'enableArrivalSat': json['enable_arrival_sat'],
        'enableArrivalSun': json['enable_arrival_sun'],
        'enableOrderdayMon': json['enable_orderday_mon'],
        'enableOrderdayTue': json['enable_orderday_tue'],
        'enableOrderdayWed': json['enable_orderday_wed'],
        'enableOrderdayThu': json['enable_orderday_thu'],
        'enableOrderdayFri': json['enable_orderday_fri'],
        'enableOrderdaySat': json['enable_orderday_sat'],
        'enableOrderdaySun': json['enable_orderday_sun'],
        'shipPreviousStockFlg': ShipPreviousStockFlgFromJSON(json['ship_previous_stock_flg']),
        'todayShipRecDelayFlg': TodayShipRecDelayFlgFromJSON(json['today_ship_rec_delay_flg']),
        'calcStockShippingorderFlg': CalcStockShippingorderFlgFromJSON(json['calc_stock_shippingorder_flg']),
        'internalTransferHubFlg': InternalTransferHubFlgFromJSON(json['internal_transfer_hub_flg']),
        'internalInboundFlg': InternalInboundFlgFromJSON(json['internal_inbound_flg']),
        'centerGroupName': json['center_group_name'],
        'centerGln': json['center_gln'],
        'remarks': json['remarks'],
        'insertDatetime': (json['insert_datetime'] == null ? null : new Date(json['insert_datetime'])),
        'insertUser': json['insert_user'],
        'updateDatetime': (json['update_datetime'] == null ? null : new Date(json['update_datetime'])),
        'updateUser': json['update_user'],
        'deleteDatetime': (json['delete_datetime'] == null ? null : new Date(json['delete_datetime'])),
        'deleteUser': json['delete_user'],
        'deleteFlg': json['delete_flg'],
    };
}

export function MstCenterToJSON(json: any): MstCenter {
    return MstCenterToJSONTyped(json, false);
}

export function MstCenterToJSONTyped(value?: MstCenter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'center_id': value['centerId'],
        'company_id': value['companyId'],
        'org_center_id': value['orgCenterId'],
        'center_name': value['centerName'],
        'center_address': value['centerAddress'],
        'enable_shipday_mon': value['enableShipdayMon'],
        'enable_shipday_tue': value['enableShipdayTue'],
        'enable_shipday_wed': value['enableShipdayWed'],
        'enable_shipday_thu': value['enableShipdayThu'],
        'enable_shipday_fri': value['enableShipdayFri'],
        'enable_shipday_sat': value['enableShipdaySat'],
        'enable_shipday_sun': value['enableShipdaySun'],
        'enable_arrival_mon': value['enableArrivalMon'],
        'enable_arrival_tue': value['enableArrivalTue'],
        'enable_arrival_wed': value['enableArrivalWed'],
        'enable_arrival_thu': value['enableArrivalThu'],
        'enable_arrival_fri': value['enableArrivalFri'],
        'enable_arrival_sat': value['enableArrivalSat'],
        'enable_arrival_sun': value['enableArrivalSun'],
        'enable_orderday_mon': value['enableOrderdayMon'],
        'enable_orderday_tue': value['enableOrderdayTue'],
        'enable_orderday_wed': value['enableOrderdayWed'],
        'enable_orderday_thu': value['enableOrderdayThu'],
        'enable_orderday_fri': value['enableOrderdayFri'],
        'enable_orderday_sat': value['enableOrderdaySat'],
        'enable_orderday_sun': value['enableOrderdaySun'],
        'ship_previous_stock_flg': ShipPreviousStockFlgToJSON(value['shipPreviousStockFlg']),
        'today_ship_rec_delay_flg': TodayShipRecDelayFlgToJSON(value['todayShipRecDelayFlg']),
        'calc_stock_shippingorder_flg': CalcStockShippingorderFlgToJSON(value['calcStockShippingorderFlg']),
        'internal_transfer_hub_flg': InternalTransferHubFlgToJSON(value['internalTransferHubFlg']),
        'internal_inbound_flg': InternalInboundFlgToJSON(value['internalInboundFlg']),
        'center_group_name': value['centerGroupName'],
        'center_gln': value['centerGln'],
        'remarks': value['remarks'],
        'insert_datetime': value['insertDatetime'] == null ? value['insertDatetime'] : value['insertDatetime'].toISOString(),
        'insert_user': value['insertUser'],
        'update_datetime': value['updateDatetime'] == null ? value['updateDatetime'] : value['updateDatetime'].toISOString(),
        'update_user': value['updateUser'],
        'delete_datetime': value['deleteDatetime'] == null ? value['deleteDatetime'] : value['deleteDatetime'].toISOString(),
        'delete_user': value['deleteUser'],
        'delete_flg': value['deleteFlg'],
    };
}

